import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function BackgroundLayer({
  images,
  desktopImages,
  index = 0,
  zIndex = 0,
  asPortal = true,
  disabled = false,
}) {
  const [canPortal, setCanPortal] = useState(false);

  useEffect(() => {
    setCanPortal(typeof document !== "undefined" && Boolean(document.body));
  }, []);

  if (disabled || !Array.isArray(images) || images.length === 0) {
    return null;
  }

  const numericIndex = Number.isFinite(index) ? index : 0;
  const safeIndex = ((numericIndex % images.length) + images.length) % images.length;

  const mobileSrc = images[safeIndex];
  const desktopSrc =
    Array.isArray(desktopImages) && desktopImages[safeIndex]
      ? desktopImages[safeIndex]
      : mobileSrc;

  const sharedStyle = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    minHeight: "100dvh",
    backgroundPosition: "center center",
    backgroundAttachment: "scroll",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  };

  const node = (
    <div
      className="background-layer"
      data-background-index={safeIndex}
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <div
        className="background-layer__image background-layer__mobile"
        style={{
          ...sharedStyle,
          backgroundImage: `url("${mobileSrc}")`,
        }}
      />

      <div
        className="background-layer__image background-layer__desktop"
        style={{
          ...sharedStyle,
          backgroundImage: `url("${desktopSrc}")`,
        }}
      />
    </div>
  );

  if (!asPortal || !canPortal) return node;
  return createPortal(node, document.body);
}
